// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__inLa+95w","error":"Captcha_error__ZvzKHeEY"};